import { render, staticRenderFns } from "./DisneyPlanning.vue?vue&type=template&id=5873c4fd&scoped=true&"
import script from "./DisneyPlanning.vue?vue&type=script&lang=js&"
export * from "./DisneyPlanning.vue?vue&type=script&lang=js&"
import style0 from "./DisneyPlanning.vue?vue&type=style&index=0&id=5873c4fd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5873c4fd",
  null
  
)

export default component.exports